"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created 18.3.2021
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converter of {@link SiteNewToSimilar}.
 * @author Radek Beran
 */


var SiteNewToSimilarConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SiteNewToSimilarConverter, _DataObjectConverter_);

  function SiteNewToSimilarConverter() {
    _classCallCheck(this, SiteNewToSimilarConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteNewToSimilarConverter).apply(this, arguments));
  }

  return SiteNewToSimilarConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SiteNewToSimilarConverter = SiteNewToSimilarConverter;